import { render, staticRenderFns } from "./DisclaimerText.vue?vue&type=template&id=165c304c&scoped=true&"
import script from "./DisclaimerText.vue?vue&type=script&lang=js&"
export * from "./DisclaimerText.vue?vue&type=script&lang=js&"
import style0 from "./DisclaimerText.vue?vue&type=style&index=0&id=165c304c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "165c304c",
  null
  
)

export default component.exports